module.exports = __webpack_public_path__ + "static/media/logo-nuol.74785da5.png";